export default "__VITE_ASSET__f131692c__"